/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { extractFromRequestData } from '@veone/ngx-utilities/form';
import { Observable } from 'rxjs';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { ApiConstantsService } from '~core/services/api-constants.service';
import { PageName } from '../models/shared.models';

export function channelIdInterceptor(
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const globalFacade = inject(GlobalFacade);
  const apiConstantService = inject(ApiConstantsService);

  const pageName = globalFacade.data?.pageName as PageName | undefined;

  const currentChannel = globalFacade.currentChannel;
  const { value: skipChannelIdInterceptor } = extractFromRequestData<boolean>(
    req,
    'skipChannelIdInterceptor'
  );
  const isBlackListApi = [
    apiConstantService.accountUrl,
    apiConstantService.accessControlsUrl,
    apiConstantService.badgeUrl,
    apiConstantService.blockUrl,
    apiConstantService.categoryUrl,
    apiConstantService.thematicUrl,
    apiConstantService.channelUrl,
    apiConstantService.commentUrl,
    apiConstantService.configurationUrl,
    apiConstantService.identityMicroservice,
    apiConstantService.requestMicroservice,
    apiConstantService.notificationUrl,
    apiConstantService.tagUrl,
    apiConstantService.genreUrl
    // apiConstantService.accountUrl,
    // apiConstantService.accountUrl,
    // apiConstantService.accountUrl,
    // apiConstantService.accountUrl
  ].some(url => req.url.includes(url));

  const isBlackListUrl = [
    PageName.homeConstructor,
    PageName.badges,
    PageName.tags
    // apiConstantService.accountUrl,
    // apiConstantService.accountUrl,
    // apiConstantService.accountUrl,
    // apiConstantService.accountUrl
  ].some(el => pageName === el);

  if (
    !skipChannelIdInterceptor &&
    !!currentChannel &&
    !isBlackListApi &&
    !isBlackListUrl
  ) {
    return next(
      req.clone({
        setHeaders: { 'X-Channel-Id': currentChannel.id }
      })
    );
  }

  return next(req);
}
